module.exports = __webpack_public_path__ + "img/hic-ovarian-cancer-female.9339600c.png";